// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createTablePickColor_pickColor__3t1EM {\n  display: flex;\n  justify-content: center;\n}\n.createTablePickColor_pickColor__3t1EM .createTablePickColor_wrap__2ma_M {\n  margin-right: 18px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.createTablePickColor_pickColor__3t1EM .createTablePickColor_image__1LRS1 {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  padding: 1px;\n  border: 2px solid var(--black-20);\n  margin: 11px;\n}\n.createTablePickColor_pickColor__3t1EM .createTablePickColor_active__3wUxd {\n  border-color: var(--white);\n}", ""]);
// Exports
exports.locals = {
	"pickColor": "createTablePickColor_pickColor__3t1EM",
	"wrap": "createTablePickColor_wrap__2ma_M",
	"image": "createTablePickColor_image__1LRS1",
	"active": "createTablePickColor_active__3wUxd"
};
module.exports = exports;
